<template>
  <v-container class="pa-0 ma-0 container" fluid>
    <v-form
        ref="form"
        v-model="isValid">
      <v-col>
        <Header :formType="formType"/>
        <RequestType :request="request" :formType="formType"/>
        <UploadFiles v-on:change="onFileChange" :formType="formType" :mandatory="false"/>
        <EntityInfo :info="user" :company="company"/>
        <Device :devices="devices" :formType="formType"/>
        <Guarantee/>
        <HowTo/>
        <Concepts/>
        <Actions v-if="!sent" v-on:cancel="onCancel" v-on:send="onSend" :company="company" :formType="formType"/>

        <div style="text-align: center; display: flex; flex-direction: column; align-items: center;">
          <v-img v-if="loading" class="img" src="https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif"></v-img>
          <h2 v-if="loading">Generando solicitud...</h2>

        </div>

        <div style="text-align: center; display: flex; flex-direction: column; align-items: center;">
          <v-img v-if="sent" class="img" src="https://www.blancopublicidad.com/assets/images/check-ok.gif"></v-img>
          <h2 v-if="sent">Hemos recibido su solicitud, en breve nos pondremos en contacto con usted</h2>

        </div>


      <div class="invalid center" align="center" v-if="showInvalid">
        Por favor, comprueba que has rellenado todos los campos obligatorios. También es obligatorio añadir como mínimo 1 producto.
      </div>
      </v-col>
    </v-form>
  </v-container>
</template>

<script>
import Concepts from "@/components/Concepts";
import Header from "@/components/Header";
import EntityInfo from "@/components/EntityInfo";
import Device from "@/components/Device";
import Actions from "@/components/Actions";
import RequestType from "@/components/RequestType";
import Guarantee from "@/components/Guarantee";
import * as axios from "axios";
import HowTo from "@/components/HowTo";
import UploadFiles from "./UploadFiles.vue";

export default {
  name: "SatForm",
  props: ["company"],
  components: { HowTo, Guarantee, RequestType, Actions, Device, EntityInfo, Header, Concepts, UploadFiles },
  data() {
    const defaultValue = ""

    return {
      formType: "sat",
      loading: false,
      showInvalid: false,
      isValid: true,
      sent: false,
      request: {
        type: "garantia",
        values: [
          {
            value: "garantia",
            label: "Garantía"
          },
          {
            value: "reparacion",
            label: "Reparación"
          },
          {
            value: "repuestos",
            label: "Repuestos"
          }
        ],
      },
      user: {
        name: defaultValue,
        address: defaultValue,
        city: defaultValue,
        state: defaultValue,
        postalCode: defaultValue,
        email: defaultValue,
        contact: defaultValue,
        phone: defaultValue,
        nif: defaultValue
      },
      devices: [],
      files: []
    }
  },
  methods: {
    onCancel() {
      this.user = {
        name: "",
        address: "",
        city: "",
        state: "",
        postalCode: "",
        email: "",
        contact: "",
        phone: ""
      }
      this.devices = []
    },
    onFileChange(f) {
      this.files = f;
      console.log(this.files);
    },
    async onSend(event) {
      this.$refs.form.validate()
      if(this.devices.length == 0) {
        this.showInvalid = true
        setTimeout(() => {
          this.showInvalid = false
        }, 5000)
        return;
      }
      if (this.isValid) {
        this.loading = true
        const body = {
          formType: this.formType,
          user: this.user,
          type: this.request.type,
          devices: this.devices,
          terms: event.terms,
          privacy: event.privacy,
          company: this.company
        }

        const formData = new FormData();
        formData.append("body", JSON.stringify(body))

        console.log(JSON.stringify(body))

        for (let i = 0; i < this.files.length; i++) {
          formData.append("file" + i, this.files[i])
        }

        const response = await axios.post(
          "https://fibraclim.com/sat_v2/push_v2.php", 
          formData,
          { "Content-Type": "multipart/form-data" }
        )
        if (response.data === "ok") {
          this.sent = true
        }

        this.loading = false
      } else {
        this.showInvalid = true
        setTimeout(() => {
          this.showInvalid = false
        }, 5000)
      }
    }
  }
} 
</script>

<style scoped>

.container {
  width: 100%;
}

.img {
  border-radius: 1000px;
  width: 200px;
  height: 200px;
  text-align: center;
}

.invalid {
  font-weight: bold;
  color: red;
}
</style>